import React, { useState, useMemo, useEffect,useRef } from 'react';
import cn from 'classnames';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import styles from './index.module.css';
import base from '../../styles/base.module.css';
import Car2 from '../../icons/Car2';
import Watch2 from '../../icons/Watch2';
import Tshirt from '../../icons/Tshirt';
import User2 from '../../icons/User2';
import Alcohol2 from '../../icons/Alcohol2';
import Diamond2 from '../../icons/Diamond2';
import OwnerItem from './OwnerItem';
import { Tooltip } from '../../components/Tooltip';
import { ModalNew2 } from '../../components/ModalNew2';
import { Tab, Tabs } from '../../common/Tabs';
import { FadeDescription } from '../../components/FadeDescription';
import Check5 from '../../icons/Check5';
import { useDynamicPagination } from '../../hooks/useDynamicPagination/useDynamicPagination';
import OwnerItemSkeleton from './OwnerItemSkeleton';
import { useOutsideClick } from '../../hooks/useOutsideClick/useOutsideClick';
import { useGetPagesQuery } from '../../redux/api/dataService';

const OWNER_REQUEST_URL = `${process.env.REACT_APP_BACKEND_URL}/admin_service/api/v1/token_owners/`;
const PAGE_SIZE = 10;

const handleSelectFilterByUserlevel = (value, setSelectedFilter, setRefetch) => {
    setRefetch(true);
    setSelectedFilter((prev) => {
        return prev.map((filter) => {
            if (filter.value === value) {
                return { ...filter, state: !filter.state };
            }
            return { ...filter, state: false };
        });
    });
};

const getSelectedLevelsQueryString = (selectedUserLevels) => {
    const findedActiveLevel = selectedUserLevels.filter((level) => level.state === true);
    return findedActiveLevel[0].value;
};

const OwnersPage = () => {
    const [pages,setPages] = useState([])
    const [tokenModal, setTokenModal] = React.useState(false);
    const [tokenManualModal, setTokenManualModal] = React.useState(false);
    const [searchValue, setSearchValue] = useState('');
    const [showFilterSearch, setShowFilterSearch] = React.useState(false);
    const [showFilterCollections, setShowFilterCollections] = React.useState(false);
    const [showFilterPrice, setShowFilterPrice] = React.useState(false);
    const [selecteduserLevels, setSelectedUserLevels] = useState([
        {
            state: false,
            value: 'bronze',
        },
        {
            state: false,
            value: 'silver',
        },
        {
            state: false,
            value: 'gold',
        },
    ]);
    // const pages = useSelector((state) => state.pages.entities);
    // const data = useGetPagesQuery()
    // console.log(data)
    const [collectionFilterItems, setCollectionFilterItems] = React.useState({});
    const [refetch, setRefetch] = useState(false);
    // const [pages,setPages] = useState(null)
    const componentRef = React.useRef(null);
    const buttonRef = React.useRef(null);
    const navigate = useNavigate();

    useEffect(() => {
        fetch(`${process.env.REACT_APP_BACKEND_URL}/admin_service/api/v1/page/`,{
            method:'GET',
            headers:{
                'Content-type':'application/json'
            }
        })
            .then((res) => {
                return res.json();
            })
            .then((response) => {
                if (response.results) {
                    setPages(response.results);
                }
            }).catch((err) => console.log(err));
    }, []);
    // console.log(pages);
    const getSelectedLevelQuery = useMemo(() => {
        const ifLevelsSelected = selecteduserLevels.some((level) => level.state === true);
        if (ifLevelsSelected) {
            return getSelectedLevelsQueryString(selecteduserLevels);
        }
    }, [selecteduserLevels]);

    const { items, loading } = useDynamicPagination(
        OWNER_REQUEST_URL,
        [
            {
                title: 'page_size',
                value: PAGE_SIZE,
            },
            {
                title: 'level',
                value: getSelectedLevelQuery,
            },
            {
                title: 'search_text',
                value: searchValue.trim(),
            },
            ...Object.values(collectionFilterItems).map((page) => {
                return {
                    title: 'page_id',
                    value: page,
                };
            }),
        ],
        false,
        refetch,
        setRefetch,
    );

    const addCollectionFilter = (id, name) => {
        setCollectionFilterItems((prev) => ({ ...prev, [name]: prev[name] ? null : id }));
        setRefetch(true);
    };

    const autoPage = pages[0]
    // console.log(pages)
    const inputRef = useRef();
    useOutsideClick(inputRef, () => setShowFilterSearch(false));
    return (
        <div className={base.marginWrapper}>
            <section className={styles.owners}>
                <img src="/assets/img/owners-bg.png" alt="main bg" className={styles.ownersBg} />

                <div className={base.container}>
                    <div className={styles.ownersInner}>
                        <h1 className={styles.ownersTitle}>Рейтинг</h1>

                        <FadeDescription
                            className={styles.ownersText}
                            description={`Ваш личный бренд начинается здесь! В современном обществе токенизация становится настоящим трендом, позволяя вам не только инвестировать в предметы роскоши, но и формировать свой уникальный личный бренд. Каждая вещь, которую вы выбираете, отражает вашу индивидуальность, статус и уровень успеха.
        
                        С CheckBrand у вас есть возможность поделиться своим стилем и влиянием с миром. Дайте знать всем о своих уникальных вещах и позвольте им стать частью вашей истории.
                        
                        Присоединяйтесь к нам и откройте для себя мир, где ваши брендовые активы могут сиять на глобальной арене.`}
                        />

                        <div className={styles.ownersButtons}>
                            <button
                                className={cn(base.orangeButton, styles.ownersButton)}
                                onClick={() => setTokenManualModal((prev) => !prev)}
                            >
                                Токенизировать свой авто
                            </button>

                            <button
                                className={cn(base.whiteButton, styles.ownersButton)}
                                onClick={() => setTokenModal((prev) => !prev)}
                            >
                                Узнать подробнее
                            </button>
                        </div>

                        <div className={styles.ownersContent}>
                            <div className={styles.filtersMobile}>
                                <button
                                    className={cn(styles.filtersMobileItem, {
                                        [styles.active]: showFilterSearch,
                                    })}
                                    onClick={() => {
                                        setShowFilterSearch(true);
                                        setShowFilterCollections(false);
                                        setShowFilterPrice(false);
                                    }}
                                    ref={buttonRef}
                                >
                                    Поиск
                                </button>

                                <div className={styles.filtersMobileItemWrapper}>
                                    <button
                                        className={cn(styles.filtersMobileItem, {
                                            [styles.active]: showFilterCollections,
                                        })}
                                        onClick={() => {
                                            setShowFilterCollections((prev) => !prev);
                                            setShowFilterSearch(false);
                                            setShowFilterPrice(false);
                                        }}
                                    >
                                        Коллекция токенов
                                    </button>

                                    <div
                                        style={{ backgroundColor: '#2072e2' }}
                                        className={cn(styles.filtersMobileContent, {
                                            [styles.active]: showFilterCollections,
                                        })}
                                    >
                                        {
                                            pages.map((page) => {
                                                return (
                                                    <button
                                                        disabled={loading}
                                                        className={cn(
                                                            styles.filtersMobileContentItem,
                                                            {
                                                                [styles.active]:
                                                                    collectionFilterItems[
                                                                        page.name
                                                                    ],
                                                            },
                                                        )}
                                                        onClick={() =>
                                                            addCollectionFilter(page.id, page.name)
                                                        }
                                                    >
                                                        <span className={styles.filterMobileWrap}>
                                                            <span
                                                                className={
                                                                    styles.filterMobileItemIcon
                                                                }
                                                            >
                                                                <img
                                                                    style={{
                                                                        width: '20px',
                                                                        height: '20px',
                                                                    }}
                                                                    src={`${page.icon}`}
                                                                />
                                                            </span>
                                                            {page.name}
                                                        </span>

                                                        <span
                                                            className={styles.filterMobileItemCheck}
                                                        >
                                                            <Check5 />
                                                        </span>
                                                    </button>
                                                );
                                            })}
                                        {/* <div className={styles.filtersMobileContentWrapper}>
                                            <div className={styles.filtersMobileContentInner}>
                                                <button
                                                    className={cn(styles.filtersMobileContentItem, {
                                                        [styles.active]:
                                                            collectionFilterItems.includes('1'),
                                                    })}
                                                    onClick={() => addCollectionFilter('1')}
                                                >
                                                    <span className={styles.filterMobileWrap}>
                                                        <span
                                                            className={styles.filterMobileItemIcon}
                                                        >
                                                            <Car2 />
                                                        </span>
                                                        Автомобили
                                                    </span>

                                                    <span className={styles.filterMobileItemCheck}>
                                                        <Check5 />
                                                    </span>
                                                </button>

                                                <button
                                                    className={cn(styles.filtersMobileContentItem, {
                                                        [styles.active]:
                                                            collectionFilterItems.includes('2'),
                                                    })}
                                                    onClick={() => addCollectionFilter('2')}
                                                >
                                                    <span className={styles.filterMobileWrap}>
                                                        <span
                                                            className={styles.filterMobileItemIcon}
                                                        >
                                                            <Watch2 />
                                                        </span>
                                                        Часы
                                                    </span>

                                                    <span className={styles.filterMobileItemCheck}>
                                                        <Check5 />
                                                    </span>
                                                </button>

                                                <button
                                                    className={cn(styles.filtersMobileContentItem, {
                                                        [styles.active]:
                                                            collectionFilterItems.includes('3'),
                                                    })}
                                                    onClick={() => addCollectionFilter('3')}
                                                >
                                                    <span className={styles.filterMobileWrap}>
                                                        <span
                                                            className={styles.filterMobileItemIcon}
                                                        >
                                                            <Tshirt />
                                                        </span>
                                                        Одежда
                                                    </span>

                                                    <span className={styles.filterMobileItemCheck}>
                                                        <Check5 />
                                                    </span>
                                                </button>

                                                <button
                                                    className={cn(styles.filtersMobileContentItem, {
                                                        [styles.active]:
                                                            collectionFilterItems.includes('4'),
                                                    })}
                                                    onClick={() => addCollectionFilter('4')}
                                                >
                                                    <span className={styles.filterMobileWrap}>
                                                        <span
                                                            className={styles.filterMobileItemIcon}
                                                        >
                                                            <User2 />
                                                        </span>
                                                        Аккаунт
                                                    </span>

                                                    <span className={styles.filterMobileItemCheck}>
                                                        <Check5 />
                                                    </span>
                                                </button>

                                                <button
                                                    className={cn(styles.filtersMobileContentItem, {
                                                        [styles.active]:
                                                            collectionFilterItems.includes('5'),
                                                    })}
                                                    onClick={() => addCollectionFilter('5')}
                                                >
                                                    <span className={styles.filterMobileWrap}>
                                                        <span
                                                            className={styles.filterMobileItemIcon}
                                                        >
                                                            <Alcohol2 />
                                                        </span>
                                                        Алкоголь
                                                    </span>

                                                    <span className={styles.filterMobileItemCheck}>
                                                        <Check5 />
                                                    </span>
                                                </button>
                                            </div>
                                        </div> */}
                                    </div>
                                </div>

                                <div className={styles.filtersMobileItemWrapper}>
                                    <button
                                        className={cn(styles.filtersMobileItem, {
                                            [styles.active]: showFilterPrice,
                                        })}
                                        onClick={() => {
                                            setShowFilterPrice((prev) => !prev);
                                            setShowFilterCollections(false);
                                            setShowFilterSearch(false);
                                        }}
                                    >
                                        Стоимость
                                    </button>

                                    <div
                                        className={cn(styles.filtersMobileContent, styles.right, {
                                            [styles.active]: showFilterPrice,
                                        })}
                                    >
                                        <div className={styles.filtersMobileContentWrapper}>
                                            <div className={styles.filtersMobileContentInner}>
                                                <button
                                                    disabled={loading}
                                                    className={cn(styles.filtersMobileContentItem, {
                                                        [styles.active]:
                                                            selecteduserLevels[0].state,
                                                    })}
                                                    onClick={() =>
                                                        handleSelectFilterByUserlevel(
                                                            'bronze',
                                                            setSelectedUserLevels,
                                                            setRefetch,
                                                        )
                                                    }
                                                >
                                                    <span className={styles.filterMobileWrap}>
                                                        <span
                                                            className={cn(
                                                                styles.filterMobileItemIcon,
                                                                styles.small,
                                                            )}
                                                        >
                                                            <Diamond2 />
                                                        </span>
                                                        Меньшая цена
                                                    </span>

                                                    <span className={styles.filterMobileItemCheck}>
                                                        <Check5 />
                                                    </span>
                                                </button>

                                                <button
                                                    disabled={loading}
                                                    className={cn(styles.filtersMobileContentItem, {
                                                        [styles.active]:
                                                            selecteduserLevels[1].state,
                                                    })}
                                                    onClick={() =>
                                                        handleSelectFilterByUserlevel(
                                                            'silver',
                                                            setSelectedUserLevels,
                                                            setRefetch,
                                                        )
                                                    }
                                                >
                                                    <span className={styles.filterMobileWrap}>
                                                        <span
                                                            className={cn(
                                                                styles.filterMobileItemIcon,
                                                                styles.medium,
                                                            )}
                                                        >
                                                            <Diamond2 />
                                                        </span>
                                                        Средняя цена
                                                    </span>

                                                    <span className={styles.filterMobileItemCheck}>
                                                        <Check5 />
                                                    </span>
                                                </button>

                                                <button
                                                    disabled={loading}
                                                    className={cn(styles.filtersMobileContentItem, {
                                                        [styles.active]:
                                                            selecteduserLevels[2].state,
                                                    })}
                                                    onClick={() => {
                                                        handleSelectFilterByUserlevel(
                                                            'gold',
                                                            setSelectedUserLevels,
                                                            setRefetch,
                                                        );
                                                    }}
                                                >
                                                    <span className={styles.filterMobileWrap}>
                                                        <span
                                                            className={styles.filterMobileItemIcon}
                                                        >
                                                            <Diamond2 />
                                                        </span>
                                                        Высокая цена
                                                    </span>

                                                    <span className={styles.filterMobileItemCheck}>
                                                        <Check5 />
                                                    </span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div
                                className={cn(styles.ownersFilter, {
                                    [styles.mobileActive]: showFilterSearch,
                                })}
                            >
                                <div className={styles.ownersSearchInner} ref={componentRef}>
                                    <div
                                        className={cn(styles.ownersSearchInnerWrap, {
                                            [styles.focus]: showFilterSearch,
                                        })}
                                        ref={inputRef}
                                    >
                                        <input
                                            className={styles.searchInput}
                                            type="text"
                                            placeholder="Поиск по имени, логину..."
                                            onFocus={() => setShowFilterSearch(true)}
                                            // onBlur={() => setShowFilterSearch(false)}
                                            onChange={(e) => setSearchValue(e.target.value)}
                                        />

                                        <button
                                            className={styles.searchButton}
                                            onClick={() => setRefetch(true)}
                                        >
                                            Найти
                                        </button>
                                    </div>
                                </div>

                                <div className={styles.tabsInner}>
                                    <p className={styles.tabsText}>
                                        Коллекция
                                        <br />
                                        токенов
                                    </p>
                                    {/* onClick={() =>
                                                            addCollectionFilter(page.id, page.name)
                                                        }
                                                    >
                                                        <span className={styles.filterMobileWrap}>
                                                            <span
                                                                className={
                                                                    styles.filterMobileItemIcon
                                                                }
                                                            >
                                                                <img
                                                                    style={{
                                                                        width: '20px',
                                                                        height: '20px',
                                                                    }}
                                                                    src={`${process.env.REACT_APP_BACKET_BASE_URL}/${process.env.REACT_APP_BACKET_NAME}/${page.icon}`}
                                                                />
                                     */}
                                    <Tabs>
                                        {pages.map((page) => {
                                                return (
                                                    <Tooltip placement="top" text={page.name}>
                                                        <Tab
                                                            active={
                                                                collectionFilterItems[page.name]
                                                            }
                                                            disabled={loading}
                                                            onClick={() =>
                                                                addCollectionFilter(
                                                                    page.id,
                                                                    page.name,
                                                                )
                                                            }
                                                        >
                                                            <img
                                                                style={{
                                                                    width: '20px',
                                                                    height: '20px',
                                                                }}
                                                                src={`${page.icon}`}
                                                            />
                                                        </Tab>
                                                    </Tooltip>
                                                );
                                            })}
                                    </Tabs>
                                </div>

                                <div className={styles.tabsInner}>
                                    <p className={styles.tabsText}>
                                        Стоимость
                                        <br />
                                        коллекции, руб.
                                    </p>

                                    <Tabs>
                                        <Tooltip text="Меньшая цена" placement="top" adaptive>
                                            <Tab
                                                disabled={loading}
                                                left
                                                size="small"
                                                onClick={() =>
                                                    handleSelectFilterByUserlevel(
                                                        'bronze',
                                                        setSelectedUserLevels,
                                                        setRefetch,
                                                    )
                                                }
                                            >
                                                <Diamond2
                                                    color={
                                                        selecteduserLevels[0].state
                                                            ? 'white'
                                                            : 'currentColor'
                                                    }
                                                />
                                            </Tab>
                                        </Tooltip>

                                        <Tooltip text="Средняя цена" placement="top" adaptive>
                                            <Tab
                                                disabled={loading}
                                                size="medium"
                                                onClick={() =>
                                                    handleSelectFilterByUserlevel(
                                                        'silver',
                                                        setSelectedUserLevels,
                                                        setRefetch,
                                                    )
                                                }
                                            >
                                                <Diamond2
                                                    color={
                                                        selecteduserLevels[1].state
                                                            ? 'white'
                                                            : 'currentColor'
                                                    }
                                                />
                                            </Tab>
                                        </Tooltip>

                                        <Tooltip text="Высокая цена" placement="top" adaptive>
                                            <Tab
                                                disabled={loading}
                                                right
                                                onClick={() =>
                                                    handleSelectFilterByUserlevel(
                                                        'gold',
                                                        setSelectedUserLevels,
                                                        setRefetch,
                                                    )
                                                }
                                            >
                                                <Diamond2
                                                    color={
                                                        selecteduserLevels[2].state
                                                            ? 'white'
                                                            : 'currentColor'
                                                    }
                                                />
                                            </Tab>
                                        </Tooltip>
                                    </Tabs>
                                </div>
                            </div>

                            <div className={styles.ownersItems}>
                                {items.map((owner, index) => {
                                    return <OwnerItem owner={owner} key={index} />;
                                })}
                                {loading &&
                                    new Array(PAGE_SIZE).fill('skeleton').map((_, index) => {
                                        return <OwnerItemSkeleton key={index} />;
                                    })}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <ModalNew2 value={tokenModal} setValue={setTokenModal} title="Токенизация автомобиля">
                <div className={styles.tokenModalContent}>
                    <div className={styles.tokenModalTextInner}>
                        <div className={styles.tokenModalTextScroll}>
                            <h3>Преимущества токенизации элитных автомобилей для владельцев:</h3>

                            <div className={styles.tokenModalTextPoint}>
                                <p>1. Увеличение стоимости</p>

                                <p>
                                    Уникальные автомобили, имеющие историю и особенности, имеют
                                    потенциал значительно вырасти в цене. Токенизация позволяет
                                    владельцам извлечь выгоду из такого увеличения стоимости,
                                    предлагая возможность последующей перепродажи токенов
                                    заинтересованным инвесторам.
                                </p>
                            </div>

                            <div className={styles.tokenModalTextPoint}>
                                <p>2. Привлечение внимания к автомобилю</p>

                                <p>
                                    Токенизация создает интерес как среди потенциальных покупателей,
                                    так и среди коллекционеров. Уникальные токены становятся
                                    элементом маркетинга, подчеркивающим индивидуальность каждого
                                    автомобиля.
                                </p>
                            </div>

                            <div className={styles.tokenModalTextPoint}>
                                <p>3. Поддержка сообщества</p>

                                <p>
                                    Создание сообщества владельцев токенов помогает обмениваться
                                    опытом и советами. Владельцы могут обсуждать тонкости ухода за
                                    автомобилем и инвестиционные возможности, что укрепляет связь
                                    между участниками.
                                </p>
                            </div>

                            <div className={styles.tokenModalTextPoint}>
                                <p>4. Участие в эксклюзивных мероприятиях</p>

                                <p>
                                    Владельцы токенов могут получить доступ к закрытым мероприятиям,
                                    выставкам и гонкам. Это не только увеличивает престиж, но и
                                    создает уникальные возможности для общения и налаживания связей
                                    с другими энтузиастами.
                                </p>
                            </div>

                            <div className={styles.tokenModalTextPoint}>
                                <p>5. Маркетинговые возможности</p>

                                <p>
                                    Токены могут стать инструментом для продвижения Вашего бренда
                                    или услуги. Выделяясь на фоне конкурентов, можно создать
                                    уникальные предложения для клиентов и партнеров.
                                </p>
                            </div>

                            <div className={styles.tokenModalTextPoint}>
                                <p>6. Инновационные технологии</p>

                                <p>
                                    Токенизация — это шаг в будущее, показывающий Вашу
                                    приверженность новым технологиям и современным подходам в
                                    управлении активами. Это сигнализирует о Вашей осведомленности и
                                    желании двигаться вперед.
                                </p>
                            </div>

                            <div className={styles.tokenModalTextPoint}>
                                <p>7. Персонализация</p>

                                <p>
                                    Возможность создания уникальных токенов, связанных с конкретным
                                    автомобилем, придает каждому авто индивидуальность. Каждый токен
                                    может отражать его историю и ключевые характеристики, что делает
                                    его уникальным предметом коллекционирования.
                                </p>
                            </div>

                            <div className={styles.tokenModalTextPoint}>
                                <p>8. Поддержка экосистемы</p>

                                <p>
                                    Участие в растущей экосистеме токенизированных активов открывает
                                    новые горизонты для взаимодействия с другими инвесторами и
                                    коллекционерами. Это создает возможность для расширения бизнеса
                                    и выхода на новые рынки.
                                </p>
                            </div>

                            <div className={styles.tokenModalTextPoint}>
                                <p>9. Демонстрация своей уникальности</p>

                                <p>
                                    Токенизация позволяет выделяться среди друзей, знакомых и
                                    коллег. Это акцентирует внимание на Вашем автомобиле и
                                    демонстрирует Ваш статус среди коллекционеров.
                                </p>
                            </div>

                            <div className={styles.tokenModalTextPoint}>
                                <p>10. Коллекционирование токенов</p>

                                <p>
                                    Токены становятся не только финансовым активом, но и предметом
                                    коллекционирования. Ведение коллекции токенов автомобилей
                                    добавляет новый уровень интереса и увлечения.
                                </p>
                            </div>

                            <div className={styles.tokenModalTextPoint}>
                                <p>11. Индивидуальные впечатления</p>

                                <p>
                                    Возможность удивить знакомых новой фичей токенизации, обсуждать
                                    уникальность своего автомобиля и делиться историей его
                                    токенизации создает дополнительные социальные связи и
                                    впечатления.
                                </p>
                            </div>

                            <div className={styles.tokenModalTextPoint}>
                                <p>12. Лидерство среди коллекционеров</p>

                                <p>
                                    Если у Вас есть несколько автомобилей, токенизация позволит Вам
                                    стать заметной фигурой среди коллекционеров. Вы можете
                                    установить статус и продемонстрировать свое лидерство в этой
                                    сфере.
                                </p>
                            </div>

                            <div className={styles.tokenModalTextPoint}>
                                <p>13. Аттракция внимания</p>

                                <p>
                                    Токенизация автомобиля может стать отличным способом привлечения
                                    внимания со стороны противоположного пола, усиливая Ваш
                                    публичный имидж и репутацию среди автолюбителей.
                                </p>
                            </div>

                            <div className={styles.tokenModalTextPoint}>
                                <p>14. Демонстрация превосходства своего автомобиля</p>

                                <p>
                                    Уникальные токены подчеркивают индивидуальность Вашего
                                    автомобиля, делая его более привлекательным для потенциальных
                                    покупателей и коллекционеров.
                                </p>
                            </div>

                            <div className={styles.tokenModalTextPoint}>
                                <p>15. Актив для последующей продажи</p>

                                <p>
                                    Токены могут находиться в обороте, что позволяет их перепродажу
                                    другим коллекционерам. Это открывает новые возможности для
                                    инвестиционной деятельности.
                                </p>
                            </div>

                            <div className={styles.tokenModalTextPoint}>
                                <p>16. Учёт имущества</p>

                                <p>
                                    Токенизация позволяет надежно вести учет своего имущества. Все
                                    данные о токенах и связанных с ними автомобилях доступны в любой
                                    момент, что облегчает управление активами.
                                </p>
                            </div>

                            <p>
                                <strong>Заключение:</strong> Токенизация элитных автомобилей — это
                                не просто тренд, а реальная возможность для владельцев поднять
                                интерес к своим автомобилям и извлечь из этого финансовую выгоду.
                            </p>
                        </div>
                    </div>

                    <button
                        className={cn(base.orangeButton, styles.tokenModalButton)}
                        onClick={() => {
                            setTokenManualModal(true);
                        }}
                    >
                        Токенизировать свой авто
                    </button>
                </div>
            </ModalNew2>

            <ModalNew2
                value={tokenManualModal}
                setValue={setTokenManualModal}
                title="Инструкция токенизации автомобиля"
            >
                <div className={styles.tokenManualModalContent}>
                    <div className={styles.tokenManualPoints}>
                        <p className={styles.tokenManualPoint}>
                            <span>
                                <svg
                                    width="13"
                                    height="13"
                                    viewBox="0 0 13 13"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M6.53892 0C10.1198 0 13 2.83593 13 6.43832C13 9.96407 10.1198 12.8 6.53892 12.8C2.88024 12.8 0 9.96407 0 6.43832C0 2.83593 2.88024 0 6.53892 0ZM7.5509 5.44192L11.3653 4.29222C10.509 2.45269 8.64072 1.22635 6.53892 1.22635C4.35928 1.22635 2.49102 2.45269 1.71257 4.29222L5.4491 5.44192C5.99401 4.90539 7.00599 4.90539 7.5509 5.44192ZM11.6766 5.44192L7.94012 6.59162C7.86228 7.0515 7.5509 7.43473 7.08383 7.66467V11.5737C10.1976 11.1904 12.2994 8.35449 11.6766 5.44192ZM5.91617 11.5737V7.66467C5.4491 7.43473 5.13772 7.0515 5.13772 6.59162L1.32335 5.44192C0.778443 8.35449 2.8024 11.1904 5.91617 11.5737Z"
                                        fill="currentColor"
                                    />
                                </svg>
                            </span>
                            Выберите бренд своего авто
                        </p>

                        <p className={styles.tokenManualPoint}>
                            <span>
                                <svg
                                    width="14"
                                    height="14"
                                    viewBox="0 0 14 14"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M6.75391 0V6.7936H13.5089C13.5089 3.0272 10.4989 0 6.75391 0Z"
                                        fill="currentColor"
                                    />
                                    <path
                                        d="M6.755 13.5905V6.79688H0C0 10.5633 3.01 13.5905 6.755 13.5905Z"
                                        fill="currentColor"
                                    />
                                </svg>
                            </span>
                            Выберите марку своего авто
                        </p>

                        <p className={styles.tokenManualPoint}>
                            <span>
                                <svg
                                    width="9"
                                    height="11"
                                    viewBox="0 0 9 11"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M7.93846 0H3.14891V1.62901C3.14773 2.25757 2.56802 2.7672 1.85303 2.76824H0V10.0668C0.00059332 10.5817 0.475872 10.9995 1.06152 11H7.93848C8.52413 10.9995 8.99941 10.5817 9 10.0668V0.93318C8.99941 0.41833 8.52411 0.000520792 7.93846 0ZM7.65365 9.71318H1.34632C1.28105 9.71318 1.22765 9.66675 1.22765 9.60885C1.22765 9.55147 1.28105 9.50453 1.34632 9.50453H7.65365C7.71892 9.50453 7.77232 9.55147 7.77232 9.60885C7.77232 9.66675 7.71892 9.71318 7.65365 9.71318ZM7.65365 8.53899L1.34632 8.53951C1.28105 8.53951 1.22765 8.49257 1.22765 8.43519C1.22765 8.37729 1.28105 8.33086 1.34632 8.33086H7.65365C7.71892 8.33086 7.77232 8.37729 7.77232 8.43519C7.77232 8.49257 7.71892 8.53899 7.65365 8.53899ZM7.65365 7.3648L1.34632 7.36533C1.28105 7.36533 1.22765 7.31838 1.22765 7.261C1.22765 7.20362 1.28105 7.15668 1.34632 7.15668H7.65365C7.71892 7.15668 7.77232 7.20362 7.77232 7.261C7.77232 7.31838 7.71892 7.3648 7.65365 7.3648ZM7.65365 6.19062L1.34632 6.19114C1.28105 6.19114 1.22765 6.14471 1.22765 6.08681C1.22765 6.02943 1.28105 5.98249 1.34632 5.98249H7.65365C7.71892 5.98249 7.77232 6.02943 7.77232 6.08681C7.77232 6.14471 7.71892 6.19062 7.65365 6.19062ZM7.65365 5.01643L1.34632 5.01748C1.28105 5.01748 1.22765 4.97053 1.22765 4.91315C1.22765 4.85525 1.28105 4.80882 1.34632 4.80882H7.65365C7.71892 4.80882 7.77232 4.85525 7.77232 4.91315C7.77232 4.97053 7.71892 5.01748 7.65365 5.01748V5.01643ZM7.65365 3.84224L1.38308 3.84329C1.31722 3.84329 1.26441 3.79634 1.26441 3.73896C1.26441 3.68158 1.31722 3.63464 1.38308 3.63464H7.65365C7.71892 3.63464 7.77232 3.68158 7.77232 3.73896C7.77232 3.79634 7.71892 3.84329 7.65365 3.84329V3.84224ZM7.65365 2.66806L4.29879 2.6691C4.23352 2.6691 4.18012 2.62268 4.18012 2.56478C4.18012 2.5074 4.23352 2.46045 4.29879 2.46045H7.65365C7.71892 2.46045 7.77232 2.5074 7.77232 2.56478C7.77232 2.62268 7.71892 2.6691 7.65365 2.6691V2.66806ZM7.65365 1.49387L5.02867 1.49544C4.96281 1.49544 4.91 1.44849 4.91 1.39111C4.91 1.33321 4.96281 1.28679 5.02867 1.28679H7.65365C7.71892 1.28679 7.77232 1.33321 7.77232 1.39111C7.77232 1.44849 7.71892 1.49544 7.65365 1.49544V1.49387ZM0.0692969 2.55956L2.88886 0.0317149C2.89776 0.0264987 2.90725 0.0223257 2.91734 0.0191959V1.62898C2.91675 2.14227 2.44325 2.55851 1.85878 2.55957L0.0692969 2.55956Z"
                                        fill="currentColor"
                                    />
                                </svg>
                            </span>
                            Выберите доступный сертификат
                        </p>

                        <p className={styles.tokenManualPoint}>
                            <span>
                                <svg
                                    width="12"
                                    height="10"
                                    viewBox="0 0 12 10"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M0.200918 5.05694L0.820371 4.42373C0.949746 4.29148 1.12271 4.21816 1.30623 4.21816C1.48975 4.21816 1.66201 4.29148 1.79209 4.42373L3.64342 6.3162L9.62139 0.205383C9.88928 -0.0684609 10.3245 -0.0684609 10.5924 0.205383L11.2119 0.83932C11.3412 0.97157 11.4129 1.14838 11.4129 1.33598C11.4129 1.52357 11.3412 1.69966 11.2119 1.83263L4.12857 9.07188C3.86068 9.34573 3.42545 9.34573 3.15756 9.07188L0.200918 6.04954C-0.0669726 5.77569 -0.0669726 5.33079 0.200918 5.05694Z"
                                        fill="currentColor"
                                    />
                                </svg>
                            </span>
                            Перейдите к оформлению
                        </p>
                    </div>

                    <button
                        className={cn(base.orangeButton, styles.tokenModalButton)}
                        onClick={() => {
                            // if (autoPage) {
                                navigate(`/brandsnew/brands`)
                            // }
                        }}
                    >
                        Перейти к выбору бренда
                    </button>
                </div>
            </ModalNew2>
        </div>
    );
};

export default OwnersPage;

{
    /* <div className={styles.ownersItem}>
<img
    src="/assets/img/brand-light.png"
    alt="light"
    className={styles.ownersItemLight}
/>

<div className={styles.ownersItemWrapper}>
    <div className={styles.ownersItemUser}>
        <UserAvatar
            avatar="/assets/img/avatar2.png"
            style="gold"
        />

        <div className={styles.ownersItemUserInfo}>
            <p className={styles.ownersItemUserName}>
                Виктор Сергеевич
            </p>

            <p className={styles.ownersItemUserRole}>
                Collector Adran
            </p>
        </div>
    </div>

    <div className={styles.ownersItemCollections}>
        <div className={styles.ownersItemCollection}>
            <img src="/assets/img/brand1.jpg" alt="brand" />
        </div>

        <div className={styles.ownersItemCollection}>
            <img src="/assets/img/brand2.jpg" alt="brand" />
        </div>

        <div className={styles.ownersItemCollection}>
            <img src="/assets/img/brand1.jpg" alt="brand" />
        </div>

        <div className={styles.ownersItemCollection}>
            <img src="/assets/img/brand2.jpg" alt="brand" />
        </div>

        <Link
            to="#"
            className={styles.ownersItemCollectionsMore}
        >
            Ещё 10
        </Link>
    </div>

    <p className={cn(styles.ownersItemPrice, styles.gold)}>
        <span>38,7 млн</span>
    </p>
</div> */
}
// </div>
